import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { setLenis } from "@/lib/scroll";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import Values from "@/components/site/Values";
import Testimonials from "@/components/site/Testimonials";
import LeadForm from "@/components/site/LeadForm";
import Footer from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="min-h-screen overflow-x-clip bg-ink font-sans text-white antialiased">
      <div className="noise-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Process />
        <Values />
        <Testimonials />
        <LeadForm />
      </main>
      <Footer />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
